/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {LonerReelModel} from "../../reels/LonerReelModel";
import {LonerStatics} from "../../LonerStatics";
import {LonerMainReelView} from "./LonerMainReelView";
import {Loner} from "../../Loner";
import {LonerGameMode} from "../../server/LonerGameMode";

export class LonerMainAllReelsView extends PIXI.Container implements StageLayer {

    private _mainReelModels: LonerReelModel[];
    private _longestReelSymbolBufferSize: number;
    private _mainReelsContainer: PIXI.Container;

    constructor() {
        super();
        if (Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
            this.visible = false;
        }
        if (Loner.model.isRestore == true) {
            if (Loner.model.data.mode == LonerGameMode.NORMAL && (Loner.model.data.nextMode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK)) {
                this.visible = false;
            }
        }
        this.init();
    }

    private init():void {
        this._mainReelsContainer = new PIXI.Container();
        this._longestReelSymbolBufferSize = 0;

        this._mainReelsContainer.position = LonerStatics.MAIN_REELS_VIEW_POSITION;
        this.addChild(this._mainReelsContainer);

        this._mainReelModels = [];
        for (let i: number = 0; i < LonerStatics.defaultGameAreaSize.length; i++) {
            const reelModel: LonerReelModel = new LonerReelModel(i);
            this._mainReelsContainer.addChild(<LonerMainReelView>reelModel.reelView);
            this._mainReelModels.push(reelModel);
        }

        if (Loner.model.data.mode == LonerGameMode.NORMAL) {
            this.enableAllViews();
        }
    }

    public enableAllViews(): void {
        let tempReel: string[];
        for (let i: number = 0; i < LonerStatics.defaultGameAreaSize.length; i++) {
            tempReel = [];
            for (let j: number = 0; j < 9; j++) {
                if (Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK || Loner.model.data.mode == LonerGameMode.FEATURE_TICK_TICK_BOOM || Loner.model.data.mode == LonerGameMode.FEATURE_PIN_THE_WIN) {
                    tempReel.push(Loner.model.reelsEnteringFreespin[i][j]);
                } else {
                    tempReel.push(Loner.model.data.reels[i][j]);
                }
            }
            this._mainReelModels[i].reelView.populateReel(tempReel);
        }
    }

    public resetAllReels(): void {
        for (let i: number = 0; i < this._mainReelModels.length; i++) {
            this._mainReelModels[i].reelView.cleanUpReel();
        }
    }

    get mainReelModels(): LonerReelModel[] {
        return this._mainReelModels;
    }
}